module.exports = __webpack_public_path__ + "media/react-logo.a4e7a6c8.mp4";